import axios from "axios";
import store from "../redux/store";
import { signOut } from "../redux/user/userAction";
/***
 *   axios再封装，自动增加token
 * @param url 地址
 * @param data 数据
 */

export default function httpRequest(url: string, data: object = {}, config?: any) {
    return axios(Object.assign({
        method: 'post',
        url: url,
        headers: { 'Authorization': 'Bearer ' + store.getState().user.token },
        data: data,
        validateStatus: function (status: number) {
            return (status >= 200 && status < 300) || status === 403; // default
        },
    }, config)).then(response => {
        if (response.status === 200) {
            return response;
        } else if (response.status === 403) {
            store.dispatch(signOut());
        }
        return response;
    })
}